module.exports = __webpack_public_path__ + "img/ins-payment.7c8346b2.svg";